// src/game/crazy/MysteryBoxModal.jsx
import React, { useState, useEffect } from "react";
import { getRandomOutcome } from "./mysteryOutcomes";

export default function MysteryBoxModal({ show, onClose, onResult, box }) {
  const [renderedKey, setRenderedKey] = useState(null);
  const [outcome, setOutcome] = useState(null);
  const [revealed, setRevealed] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0); // 0 = Open, 1 = Ignore

  const handleOpen = () => {
    const result = getRandomOutcome();
    setOutcome(result);
    setRevealed(true);

    setTimeout(() => {
  onResult?.({ ...result, key: box.key }); // ✅ Only call one handler
}, 1800);

  };

  const handleIgnore = () => {
    setOutcome(null);
    setRevealed(false);
    onClose();
  };
  useEffect(() => {
  const handleKeyDown = (e) => {
    if (revealed) return; // Don't allow nav after reveal

    if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
      setSelectedIndex((prev) => (prev === 0 ? 1 : 0));
    }

    if (e.key === "Enter") {
      if (selectedIndex === 0) handleOpen();
      else handleIgnore();
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => window.removeEventListener("keydown", handleKeyDown);
}, [selectedIndex, revealed]);

  // Reset when a new box appears
  useEffect(() => {
    if (box?.key && box.key !== renderedKey) {
      
      setRenderedKey(box.key);
      setOutcome(null);
      setRevealed(false);
    }
  }, [box, renderedKey]);

  // Optional debug
  useEffect(() => {
    
  }, []);

  // Guard to prevent render without box or show flag
  if (!show || !box || renderedKey !== box.key) return null;

  


  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
        background: "white",
        padding: "1.5rem",
        borderRadius: "1rem",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        width: "90%",
        maxWidth: "400px",
        textAlign: "center"
      }}
    >
      <h2 className="text-2xl font-bold mb-4">🎁 Mystery Box!</h2>

      {!revealed ? (
        <>
          <p className="text-lg mb-6">Do you want to open it?</p>
          <div className="flex justify-center gap-4">
            <button
  onClick={handleOpen}
  className={`px-4 py-2 rounded font-semibold ${
    selectedIndex === 0 ? "bg-green-700 text-white" : "bg-green-500 text-white"
  }`}
>
  Open
</button>

            <button
  onClick={handleIgnore}
  className={`px-4 py-2 rounded font-semibold ${
    selectedIndex === 1 ? "bg-gray-500 text-white" : "bg-gray-300 text-black"
  }`}
>
  Ignore
</button>

          </div>
        </>
      ) : (
        <>
          <p className="text-lg mb-4">
            {outcome?.type === "delight"
              ? "🌟 It's your lucky day!"
              : "😱 Uh oh..."}
          </p>
          <p className="text-xl font-semibold">{outcome?.message}</p>
        </>
      )}
    </div>
  );
}
